import {observer} from "mobx-react";
import type {User} from "../../../../data/models/User";
import {XyiconFeature} from "../../../../generated/api/base";
import {useAppStore} from "../../../../StateManager";
import {SelectInput} from "../select/SelectInput";
import type {IInputProps} from "../clicktoedit/FieldInput";
import {compareUsers, renderUserValue} from "../../../../data/models/field/datatypes/PeopleSingle";

export const PeopleSingleChoiceInput = observer((props: IInputProps) => {
	const {value, onChange} = props;
	const appState = useAppStore((state) => state.appState);
	const allUsers = appState.actions.getList<User>(XyiconFeature.User).toSorted(compareUsers);
	const selectedUserMaybe = value as User;

	return (
		<SelectInput
			fullWidth={true}
			{...props}
			selected={selectedUserMaybe}
			options={allUsers}
			nullOption={true}
			nullLabel=""
			render={renderUserValue}
			onChange={(userMaybe?: User) => onChange(userMaybe?.id ?? null)}
		/>
	);
});
